export default __webpack_public_path__ + "static/media/steam.a7eaff26.png";